export const formatDate = (date) => {
    try {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const d = new Date(date);

        return d.toLocaleDateString("en-US", options);
    } catch (err) {
        return date;
    }
}